import { useState, useEffect } from "react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Hardcoded credentials
const LAINNYA_USER = {
  username: "admin@lainnya.com",
  password: "123123"
};

function LainnyaLogin({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    if (username === LAINNYA_USER.username && password === LAINNYA_USER.password) {
      localStorage.setItem("lainnya_auth", "true");
      onLogin(true);
    } else {
      setError("Username atau password salah");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-700 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">📍</span>
          </div>
          <h1 className="text-2xl font-bold text-slate-800">Perbaiki Provinsi</h1>
          <p className="text-slate-500 text-sm mt-1">Artikel dengan kategori "Lainnya"</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
              placeholder="admin@lainnya.com"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
              placeholder="••••••"
              required
            />
          </div>

          {error && (
            <div className="bg-red-50 text-red-600 px-4 py-3 rounded-xl text-sm">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-3 rounded-xl font-semibold transition disabled:opacity-50"
          >
            {loading ? "Memverifikasi..." : "Masuk"}
          </button>
        </form>

        <div className="mt-6 text-center">
          <a href="/" className="text-sm text-slate-500 hover:text-blue-600 transition">
            ← Kembali ke Website
          </a>
        </div>
      </div>
    </div>
  );
}

function LainnyaDashboard({ onLogout }) {
  const [articles, setArticles] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [search, setSearch] = useState("");
  const [updating, setUpdating] = useState(null);
  const [message, setMessage] = useState(null);
  const LIMIT = 20;

  useEffect(() => {
    loadProvinces();
    loadArticles(true);
  }, []);

  const loadProvinces = async () => {
    try {
      const res = await fetch(`${API_URL}/api/lainnya/provinces`);
      const data = await res.json();
      setProvinces(data);
    } catch (e) {
      console.error("Failed to load provinces:", e);
    }
  };

  const loadArticles = async (reset = false) => {
    setLoading(true);
    try {
      const newOffset = reset ? 0 : offset;
      const params = new URLSearchParams({
        limit: LIMIT.toString(),
        offset: newOffset.toString()
      });
      if (search) params.append("search", search);

      const res = await fetch(`${API_URL}/api/lainnya/articles?${params}`);
      const data = await res.json();
      
      setArticles(reset ? data.articles : [...articles, ...data.articles]);
      setTotal(data.total);
      setHasMore(data.has_more);
      setOffset(newOffset + LIMIT);
    } catch (e) {
      console.error("Failed to load articles:", e);
    }
    setLoading(false);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setOffset(0);
    loadArticles(true);
  };

  const handleUpdateProvince = async (articleId, provinceId) => {
    if (!provinceId) return;
    
    setUpdating(articleId);
    setMessage(null);
    
    try {
      const res = await fetch(`${API_URL}/api/lainnya/articles/${articleId}/province`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ province_id: parseInt(provinceId) })
      });
      
      const data = await res.json();
      
      if (res.ok) {
        setMessage({ type: "success", text: data.message });
        // Remove from list
        setArticles(articles.filter(a => a.id !== articleId));
        setTotal(t => t - 1);
      } else {
        setMessage({ type: "error", text: data.detail || "Gagal mengupdate" });
      }
    } catch (e) {
      setMessage({ type: "error", text: "Terjadi kesalahan" });
    }
    
    setUpdating(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("lainnya_auth");
    onLogout();
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center">
              <span className="text-xl">📍</span>
            </div>
            <div>
              <h1 className="font-bold text-gray-800">Perbaiki Provinsi "Lainnya"</h1>
              <p className="text-xs text-gray-500">Total: {total.toLocaleString()} artikel</p>
            </div>
          </div>
          <button onClick={handleLogout} className="text-sm text-gray-500 hover:text-red-600">
            Logout →
          </button>
        </div>
      </header>

      {/* Main */}
      <main className="max-w-6xl mx-auto px-4 py-6">
        {/* Message */}
        {message && (
          <div className={`mb-4 px-4 py-3 rounded-lg ${
            message.type === "success" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
          }`}>
            {message.text}
          </div>
        )}

        {/* Search */}
        <form onSubmit={handleSearch} className="mb-6 flex gap-2">
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Cari berdasarkan judul atau tags..."
            className="flex-1 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          />
          <button type="submit" className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
            Cari
          </button>
        </form>

        {/* Articles List */}
        <div className="space-y-4">
          {articles.map((article) => (
            <ArticleCard
              key={article.id}
              article={article}
              provinces={provinces}
              updating={updating === article.id}
              onUpdate={handleUpdateProvince}
            />
          ))}
        </div>

        {/* Load More */}
        {hasMore && (
          <div className="text-center mt-6">
            <button
              onClick={() => loadArticles(false)}
              disabled={loading}
              className="px-8 py-3 bg-gray-800 text-white rounded-lg hover:bg-gray-900 disabled:opacity-50"
            >
              {loading ? "Loading..." : "Muat Lebih Banyak"}
            </button>
          </div>
        )}

        {articles.length === 0 && !loading && (
          <div className="text-center py-12 text-gray-500">
            {search ? "Tidak ada artikel ditemukan" : "Semua artikel sudah dikategorikan! 🎉"}
          </div>
        )}
      </main>
    </div>
  );
}

function ArticleCard({ article, provinces, updating, onUpdate }) {
  const [selectedProvince, setSelectedProvince] = useState("");

  return (
    <div className="bg-white rounded-xl shadow-sm border p-4 flex gap-4">
      {/* Thumbnail */}
      <div className="w-24 h-24 flex-shrink-0">
        <img
          src={article.thumbnail}
          alt=""
          className="w-full h-full object-cover rounded-lg"
          onError={(e) => { e.target.src = "https://via.placeholder.com/96?text=No+Image"; }}
        />
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <h3 className="font-semibold text-gray-800 line-clamp-2 mb-1">{article.title}</h3>
        <p className="text-xs text-gray-500 mb-2">ID: {article.id}</p>
        {article.tags && (
          <p className="text-xs text-blue-600 line-clamp-1">Tags: {article.tags}</p>
        )}
      </div>

      {/* Action */}
      <div className="flex items-center gap-2 flex-shrink-0">
        <select
          value={selectedProvince}
          onChange={(e) => setSelectedProvince(e.target.value)}
          className="px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-blue-500 max-w-[180px]"
          disabled={updating}
        >
          <option value="">Pilih Provinsi</option>
          {provinces.map((p) => (
            <option key={p.id} value={p.id}>{p.name}</option>
          ))}
        </select>
        <button
          onClick={() => onUpdate(article.id, selectedProvince)}
          disabled={!selectedProvince || updating}
          className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium"
        >
          {updating ? "..." : "Simpan"}
        </button>
      </div>
    </div>
  );
}

export default function LainnyaPage() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return localStorage.getItem("lainnya_auth") === "true";
  });

  if (!isLoggedIn) {
    return <LainnyaLogin onLogin={setIsLoggedIn} />;
  }

  return <LainnyaDashboard onLogout={() => setIsLoggedIn(false)} />;
}
